<template>
  <div class="mall-user-detail">
    <div class="white-bg padding-left padding-right padding-top border-radius-top">
      <div class="flex justify-between">
        <div class="text-title">
          {{ $t('mallUser.title') }}
        </div>
        <div></div>
      </div>

      <!-- 用户信息 -->
      <div class="margin-top text-left">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('mallUser.userId') }}:
              </label>
              <label>{{ mallUserDetailInfo.userId }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('mallUser.name') }}:
              </label>
              <label>{{ mallUserDetailInfo.name || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('mallUser.email') }}:
              </label>
              <label>{{ mallUserDetailInfo.email }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('mallUser.address') }}:
              </label>
              <label>{{ mallUserDetailInfo.address || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('mallUser.tel') }}:
              </label>
              <label>{{ mallUserDetailInfo.tel || '-' }}</label>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label class="col-form-label">
                {{ $t('mallUser.createTime') }}:
              </label>
              <label>{{ mallUserDetailInfo.createTime || '-' }}</label>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="vc-line-primary margin-top"></div>

      <div class="margin-top-sm">
        <el-tabs v-model="mallUserDetailInfo._currentTab" @tab-click="changeTab(mallUserDetailInfo._currentTab)">
          <el-tab-pane label="用户积分" name="userDetailIntegral"></el-tab-pane>
          <el-tab-pane label="积分明细" name="userDetailIntegralDetail"></el-tab-pane>
          <el-tab-pane label="用户订单" name="userDetailOrder"></el-tab-pane>
          <el-tab-pane label="退货订单" name="userDetailRefundOrder"></el-tab-pane>
          <el-tab-pane label="商铺会员" name="userDetailVip"></el-tab-pane>
          <el-tab-pane label="拼团订单" name="userDetailGroupOrders"></el-tab-pane>
          <el-tab-pane label="拼团退单" name="userDetailRefundGroupOrders"></el-tab-pane>
          <el-tab-pane label="秒杀订单" name="userDetailSeckillOrders"></el-tab-pane>
          <el-tab-pane label="收货地址" name="userDetailAddress"></el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="white-bg padding-left padding-right  border-radius-bottom">
      <user-detail-integral ref="userDetailIntegral" v-if="mallUserDetailInfo._currentTab === 'userDetailIntegral'"></user-detail-integral>
      <user-detail-integral-detail
        ref="userDetailIntegralDetail"
        v-if="mallUserDetailInfo._currentTab === 'userDetailIntegralDetail'"></user-detail-integral-detail>
      <user-detail-order ref="userDetailOrder" v-if="mallUserDetailInfo._currentTab === 'userDetailOrder'"></user-detail-order>
      <user-detail-refund-order
        ref="userDetailRefundOrder"
        v-if="mallUserDetailInfo._currentTab === 'userDetailRefundOrder'"></user-detail-refund-order>
      <user-detail-vip ref="userDetailVip" v-if="mallUserDetailInfo._currentTab === 'userDetailVip'"></user-detail-vip>
      <user-detail-group-orders
        ref="userDetailGroupOrders"
        v-if="mallUserDetailInfo._currentTab === 'userDetailGroupOrders'"></user-detail-group-orders>
      <user-detail-refund-group-orders
        ref="userDetailRefundGroupOrders"
        v-if="mallUserDetailInfo._currentTab === 'userDetailRefundGroupOrders'"></user-detail-refund-group-orders>
      <user-detail-seckill-orders
        ref="userDetailSeckillOrders"
        v-if="mallUserDetailInfo._currentTab === 'userDetailSeckillOrders'"></user-detail-seckill-orders>
      <user-detail-address ref="userDetailAddress" v-if="mallUserDetailInfo._currentTab === 'userDetailAddress'"></user-detail-address>
    </div>
  </div>
</template>

<script>
import { getMallUser } from '@/api/user/mallUserApi'
import UserDetailIntegral from '@/components/user/userDetailIntegral'
import UserDetailIntegralDetail from '@/components/user/userDetailIntegralDetail'
import UserDetailOrder from '@/components/user/userDetailOrder'
import UserDetailRefundOrder from '@/components/user/userDetailRefundOrder'
import UserDetailVip from '@/components/user/userDetailVip'
import UserDetailGroupOrders from '@/components/user/userDetailGroupOrders'
import UserDetailRefundGroupOrders from '@/components/user/userDetailRefundGroupOrders'
import UserDetailSeckillOrders from '@/components/user/userDetailSeckillOrders'
import UserDetailAddress from '@/components/user/userDetailAddress'

export default {
  name: 'MallUserDetail',
  components: {
    UserDetailIntegral,
    UserDetailIntegralDetail,
    UserDetailOrder,
    UserDetailRefundOrder,
    UserDetailVip,
    UserDetailGroupOrders,
    UserDetailRefundGroupOrders,
    UserDetailSeckillOrders,
    UserDetailAddress
  },
  data() {
    return {
      mallUserDetailInfo: {
        userId: '',
        name: '',
        email: '',
        address: '',
        tel: '',
        createTime: '',
        _currentTab: 'userDetailIntegral'
      }
    }
  },
  created() {
    this.mallUserDetailInfo.userId = this.$route.query.userId
    if (!this.mallUserDetailInfo.userId) {
      return
    }
    this.listMallUser()
  },
  methods: {
    listMallUser() {
      const params = {
        page: 1,
        row: 1,
        userId: this.mallUserDetailInfo.userId
      }
      getMallUser(params).then(res => {
        Object.assign(this.mallUserDetailInfo, res.data[0])
      }).catch(error => {
        console.error('请求失败:', error)
      })
    },
    changeTab(tab) {
      this.mallUserDetailInfo._currentTab = tab
      setTimeout(() => {
        this.$refs[tab].open({
          userId: this.mallUserDetailInfo.userId,
          tel: this.mallUserDetailInfo.tel,
          userName: this.mallUserDetailInfo.name
        })
      }, 100)
    }
  }
}
</script>

<style scoped>
.mall-user-detail {
  background-color: #f5f7fa;
}

.white-bg {
  background-color: #fff;
}

.padding-left {
  padding-left: 20px;
}

.padding-right {
  padding-right: 20px;
}

.padding-top {
  padding-top: 20px;
}

.border-radius-top {
  border-radius: 4px 4px 0 0;
}

.border-radius-bottom {
  border-radius: 0 0 4px 4px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.text-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.margin-top {
  margin-top: 20px;
}

.margin-top-sm {
  margin-top: 10px;
}

.vc-line-primary {
  height: 1px;
  background-color: #ebeef5;
}

.form-group {
  margin-bottom: 15px;
}

.col-form-label {
  display: inline-block;
  margin-right: 10px;
  color: #606266;
}
</style>